module.exports = __webpack_public_path__ + "static/1-7adf863686fdeddf6f61ca6267456eb7.jpg";